import {get } from 'svelte/store';
import jQuery from 'jquery';
import {
    sketchfabId,
    linkPdfId,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
    quantite,
    commentaire,
    coordonnees,
    coordonneesProfessionel,
    coordonneesNegociant
} from '../stores.js';

export function resetTrappeOption() {
    sketchfabId.set('');
    linkPdfId.set('');
    idTrappe.set('');
    nomTrappe.set('');
    choix.set('');
    dimLongueur.set('');
    dimLargeur.set('');
    sensOuverture.set('');
    fermeture.set('');
    type.set('');
    couleur.set('');
    epaisseur.set('');
    dureeResistance.set('');
    dimLongueurIdFiche.set('');
    dimLargeurIdFiche.set('');
    sensOuvertureIdFiche.set('');
    fermetureIdFiche.set('');
    typeIdFiche.set('');
    couleurIdFiche.set('');
    epaisseurIdFiche.set('');
    dureeResistanceIdFiche.set('');
    coupeFeuIdPath.set('');
    trappePath.set('');
    quantite.set('');
    commentaire.set('');

}

export function trappeStoretoObj() {
    let idtrappe = '';
    let objTrappe = {
        sketchfabUID: get(sketchfabId),
        linkPdfId: get(linkPdfId),
        // idTrappe: get(idTrappe),
        nomTrappe: get(nomTrappe),
        choix: get(choix),
        dimLongueur: get(dimLongueur),
        dimLargeur: get(dimLargeur),
        sensOuverture: get(sensOuverture),
        fermeture: get(fermeture),
        type: get(type),
        couleur: get(couleur),
        epaisseur: get(epaisseur),
        dureeResistance: get(dureeResistance),
        dimLongueurIdFiche: get(dimLongueurIdFiche),
        dimLargeurIdFiche: get(dimLargeurIdFiche),
        sensOuvertureIdFiche: get(sensOuvertureIdFiche),
        fermetureIdFiche: get(fermetureIdFiche),
        typeIdFiche: get(typeIdFiche),
        couleurIdFiche: get(couleurIdFiche),
        epaisseurIdFiche: get(epaisseurIdFiche),
        dureeResistanceIdFiche: get(dureeResistanceIdFiche),
        coupeFeuIdPath: get(coupeFeuIdPath),
        trappePath: get(trappePath),
        quantite: get(quantite),
        commentaire: get(commentaire),
    };
    // clog.sketchfabUID = sketchfabUID;
    // console.log('++++++++++++++++++++++++++++++++++++++++++++++');
    // console.log(objTrappe);
    // console.log('++++++++++++++++++++++++++++++++++++++++++++++');
    // return clog;
    return objTrappe;
}

export async function trappeObjtoSstore(json) {

    // console.log('trappeObjtoSstore enter');
    // console.log(json);
    // nomTrappe.set(json['nomTrappe']);
    // fermeture.set(json['fermeture']);
    // dimLongueurIdFiche.set(json['dimLongueurIdFiche']);

    // let idtrappe = '';
    // let objTrappe = {
    //   sketchfabUID: '',
    //   // idTrappe: get(idTrappe),
    //   nomTrappe: get(nomTrappe),
    //   choix: get(choix),
    //   dimLongueur: get(dimLongueur),
    //   dimLargeur: get(dimLargeur),
    //   sensOuverture: get(sensOuverture),
    //   fermeture: get(fermeture),
    //   type: get(type),
    //   couleur: get(couleur),
    //   epaisseur: get(epaisseur),
    //   dureeResistance: get(dureeResistance),
    //   dimLongueurIdFiche: get(dimLongueurIdFiche),
    //   dimLargeurIdFiche: get(dimLargeurIdFiche),
    //   sensOuvertureIdFiche: get(sensOuvertureIdFiche),
    //   fermetureIdFiche: get(fermetureIdFiche),
    //   typeIdFiche: get(typeIdFiche),
    //   couleurIdFiche: get(couleurIdFiche),
    //   epaisseurIdFiche: get(epaisseurIdFiche),
    //   dureeResistanceIdFiche: get(dureeResistanceIdFiche),
    //   coupeFeuIdPath: get(coupeFeuIdPath),
    //   trappePath: get(trappePath),
    //   quantite: get(quantite),
    //   commentaire: get(commentaire),
    // };

    // return objTrappe;
    console.log('trappeObjtoSstore out');
    return Promise.resolve(json);

}

export function getTrappeInSession() {
    // console.log(`getTrappeInSession`);
    // setTimeout(() => {
    //   console.log('gggg');
    // }, "10000");
    // return 'pppp';

    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve("fast");
    //     console.log("fast promise is done");
    //   }, 5000);
    // });

    // return jQuery.getJSON('http://localhost:8073/_SeminTrappesAjax/trappeGetSession.php', function (json) {
    return jQuery.getJSON('ajax/trappeGetSession.php', function(json) {
        // jQuery.getJSON('ajax/trappeGetSession.php', function (json) {
        // console.log('=========================
        // console.log(`getTrappeInSession enter`);
        // await trappeObjtoSstore(json);
        // console.log(`getTrappeInSession out`);
        // console.log(json);
        // return new Promise((resolve) => {
        //   resolve(json);
        // });
        // return new Promise((resolve) => {
        //   setTimeout(() => {
        //     resolve("fast");
        //     console.log("fast promise is done");
        //   }, 5000);
        // });

    });

}

export async function saveTrappeInSession() {
    try {
        let objTrappe = trappeStoretoObj();
        // return = '';
        jQuery
            .post(
                // 'http://localhost:8073/_SeminTrappesAjax/trappeSaveSession.php',
                'ajax/trappeSaveSession.php', {
                    postObjTrappe: objTrappe
                },
                function(data, status) {
                    return true;
                }
            )
            .fail(function() {
                return false;
            });
    } catch (error) {
        return false;
    }
}

export function asAlert(msg) {
    alert(msg);
}

export async function saveCommande(inDb = false, professionel = '', objcoordonnees = '') {
    try {
        let objTrappe = trappeStoretoObj();
        console.log('----- saveCommande -----');
        console.log(objTrappe);
        console.log(professionel);
        console.log(objcoordonnees);

        // Retourner une Promise qui sera résolue avec le résultat de l'AJAX
        return new Promise((resolve, reject) => {
            jQuery.post(
                    // 'http://localhost/comptoirtrappe.fr/ajax/commandeSave.php', {
                    'ajax/commandeSave.php', {
                        inDb: inDb,
                        postObjTrappe: objTrappe,
                        professionel: professionel,
                        postCoordonnees: objcoordonnees,
                    }
                )
                .done(function(data) {
                    console.log(`saveCommande data : ${data}`);
                    resolve(data); // Résoudre la Promise avec la donnée reçue
                })
                .fail(function(error) {
                    console.error("Erreur AJAX:", error);
                    reject(false); // Rejeter la Promise en cas d'erreur
                });
        });
    } catch (error) {
        console.error("Erreur dans saveCommande:", error);
        return false;
    }
}

// export async function saveCommande(inDb = false, professionel = '', objcoordonnees = '') {
//     try {
//         let objTrappe = trappeStoretoObj();
//         console.log('----- saveCommande -----');
//         console.log(objTrappe);
//         console.log(professionel);
//         console.log(objcoordonnees);
//         // alert('Envoie email désactivé');
//         jQuery
//             .post(
//                 // 'http://localhost:8073/_SeminTrappesAjax/commandeSave.php',
//                 'http://localhost/comptoirtrappe.fr/ajax/commandeSave.php',
//                 // 'ajax/commandeSave.php',
//                 {
//                     inDb: inDb,
//                     postObjTrappe: objTrappe,
//                     professionel: professionel,
//                     postCoordonnees: objcoordonnees,
//                 },
//                 function(data, status) {
//                     // alert('envoie');
//                     // return true;
//                     console.log(`saveCommande data : ${data}`);
//                     return data;
//                     // if (data.valid) {
//                     //   asnavigate(navigate, '/process/negociant/recapitulatif');
//                     // }
//                     // erroMessage.textContent = 'Le code est faux';
//                     // throw new Error('Le code est faux');
//                 }
//             )
//             .fail(function() {
//                 return false;
//                 // return = "Une erreur c'est produite";
//             });
//     } catch (error) {
//         return false;
//         // erroMessage.textContent = "Une erreur c'est produite";
//         // throw new Error("Une erreur c'est produite");
//     }
// }

export async function linkToPdf(linkId) {
    try {
        jQuery
            .post(
                // 'http://localhost:8073/_SeminTrappesAjax/linkToPdf.php',
                'ajax/linkToPdf.php', {
                    linkId: linkId
                },
                function(link, status) {
                    console.log('----- linkToPdf ----- ' + linkId);
                    console.log(link);
                    const spanLinkToPdf = document.querySelector('#linkToPdf');
                    spanLinkToPdf.textContent = `${link}`;
                    return true;
                }
            )
            .fail(function() {
                return false;
            });
    } catch (error) {
        return false;
    }
}

export async function sendContact(objContact) {
    try {
        console.log('----- sendContact -----');
        console.log(objContact);
        // alert('Envoie email désactivé');
        jQuery
            .post(
                // 'http://localhost:8073/_SeminTrappesAjax/contactSend.php',
                'ajax/contactSend.php', {
                    postObjContact: objContact
                },
                function(data, status) {
                    //  alert('envo');
                    return true;
                    // console.log(data);
                    // if (data.valid) {
                    //   asnavigate(navigate, '/process/negociant/recapitulatif');
                    // }
                    // erroMessage.textContent = 'Le code est faux';
                    // throw new Error('Le code est faux');
                }
            )
            .fail(function() {
                return false;
                // return = "Une erreur c'est produite";
            });
    } catch (error) {
        return false;
        // erroMessage.textContent = "Une erreur c'est produite";
        // throw new Error("Une erreur c'est produite");
    }
} // throw new Error("Une erreur c'est produite");}